export default __webpack_public_path__ + "static/media/red-first-raccoon.5d56454c.png";